var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlidingDoodle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 636,
    height: 44,
    viewBox: "0 0 636 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8575 6.56358C8.79921 7.03996 7.7998 7.62394 6.87322 8.30158L30.0863 31.5145C30.7639 30.588 31.3479 29.5886 31.8243 28.5303L9.8575 6.56358ZM33.2746 21.27C33.0407 12.4523 25.9355 5.34715 17.1178 5.11328L33.2746 21.27ZM1.13831 15.8121C1.54256 14.7498 2.05267 13.7397 2.65575 12.7947L25.5932 35.732C24.6481 36.3351 23.638 36.8452 22.5757 37.2494L1.13831 15.8121ZM14.8472 38.2315L0.15625 23.5406C0.998259 31.2594 7.12832 37.3895 14.8472 38.2315Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.644 5.20703H117.527V38.1377H150.644V5.20703ZM145.453 10.4165H122.755V32.9284H145.453V10.4165Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.898 6.32764L234.898 10.9816L260.755 10.9816L260.755 37.0156L265.409 37.0156L265.409 6.50636L265.408 6.50636L265.408 6.32764L234.898 6.32764Z",
    fill: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.777 5.20703H349.66V38.1377H382.777V5.20703ZM377.586 10.4165H354.888V32.9284H377.586V10.4165Z",
    fill: "#1E1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M510.071 28.0926C510.523 26.897 510.845 25.6637 511.038 24.4143L474.768 24.4143C474.961 25.6637 475.284 26.897 475.735 28.0926L510.071 28.0926ZM480.258 34.8968C487.336 41.6328 498.471 41.6328 505.548 34.8968L480.258 34.8968ZM509.646 14.074C510.16 15.2175 510.55 16.4029 510.818 17.6101L474.989 17.61C475.256 16.4029 475.647 15.2175 476.16 14.0739L509.646 14.074ZM481.435 7.26973L504.371 7.26974C497.687 1.9063 488.12 1.9063 481.435 7.26973Z",
    fill: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M603.043 28.7814C615.974 28.7814 626.456 18.2994 626.456 5.36913C626.456 5.36522 626.456 5.36132 626.456 5.35742H635.653C635.653 9.64242 634.809 13.8855 633.17 17.8443C631.53 21.8031 629.126 25.4002 626.096 28.4301C623.066 31.4601 619.469 33.8635 615.51 35.5033C611.552 37.1431 607.308 37.9871 603.023 37.9871V28.7814C603.03 28.7814 603.037 28.7814 603.043 28.7814Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidingDoodle);
export default __webpack_public_path__ + "static/media/slidingDoodle.32673da7523b0b7b30a23fc52acb990b.svg";
export { ForwardRef as ReactComponent };